import { LOCIZE_NAMESPACE } from 'main/common'
import { i18nKeyPrefix } from 'main/pages/Search/i18n'
import { ageRangeLabelsAndValues, IFilters } from 'main/util/search'
import * as React from 'react'
import { TFunction, useTranslation } from 'react-i18next'
import { FilterControl } from '../common'
import IFullSearchProps from '../types'
import FilterForm from './FilterForm'

const PRE = `${i18nKeyPrefix}-FILTERS-AGE-RANGE`

// @flow
export default function AgeRangeFilter(props: IFullSearchProps) {
  const {
    filters,
    displayForm,
    palette,
    onChangeFilters,
    onRequestCloseForm,
    onRequestDisplayForm,
  } = props

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const isActive = !!(filters.enrollingAgeMonthsMin || filters.enrollingAgeMonthsMax)

  return (
    <div>
      <FilterControl
        isActive={isActive}
        label={isActive ? getActiveLabel(filters, t) : t(`${PRE}-LABEL`)}
        displayForm={displayForm}
        palette={palette}
        onRequestCloseForm={onRequestCloseForm}
        onRequestDisplayForm={onRequestDisplayForm}
        filterForm={
          <FilterForm
            filters={filters}
            onChangeFilters={onChangeFilters}
            onRequestCloseForm={onRequestCloseForm}
          />
        }
      />
    </div>
  )
}

function getActiveLabel(filters: IFilters, t: TFunction) {
  const { enrollingAgeMonthsMax: maxAge, enrollingAgeMonthsMin: minAge } = filters

  const lastIndex = ageRangeLabelsAndValues.length - 1
  const min = typeof minAge === 'number' ? minAge : 0
  const max = typeof maxAge === 'number' ? maxAge : lastIndex

  const lowAge = t(ageRangeLabelsAndValues[min]?.key, { qty: ageRangeLabelsAndValues[min]?.qty })
  const highAge = t(ageRangeLabelsAndValues[max]?.key, { qty: ageRangeLabelsAndValues[max]?.qty })

  return `${lowAge} - ${highAge}`
}
